import script from "./PUR01_010RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR01_010RPT.vue?vue&type=script&setup=true&lang=js"

import "./PUR01_010RPT.vue?vue&type=style&index=0&id=16964c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16964c08"]])

export default __exports__